import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=4c8fe98b&scoped=true&"
import script from "@/components/rating/Rating.ts?vue&type=script&lang=ts&"
export * from "@/components/rating/Rating.ts?vue&type=script&lang=ts&"
import style0 from "@/components/rating/rating.scss?vue&type=style&index=0&id=4c8fe98b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fe98b",
  null
  
)

export default component.exports